export const CLOSE_EDIT_SEASONS_MODAL_BUTTON_LABEL = "Close";
export const SEASONS_FETCH_FAILURE = "Something went wrong.";
export const EDIT_SEASONS_MODAL_HEADER = "Edit Seasons";

export const MOVE_DRAG_HANDLE_PREFIX = "Click and move the";
export const MOVE_DRAG_HANDLE_SUFFIX = "to reorder the tabs";



// WEBPACK FOOTER //
// ./src/pages/director/seasons/components/seasons-editor/components/edit-seasons-modal/constants.ts